export function ensureOnePrimary(
  object,
  index,
  keyName = 'is_primary',
  forcePrimary = false,
) {
  const selectedData = object[index]
  if (selectedData && selectedData[keyName]) {
    object.forEach((item, key) => {
      if (key !== index) {
        item[keyName] = false
      }
    })
  }
  if (forcePrimary) {
    // reset first primary item
    if (selectedData && !selectedData[keyName]) {
      if (index !== 0){
        object[0][keyName] = true
      }else{
        object[1][keyName] = true
      }
    }
  }
}